import React from 'react';
import { IconButton } from '@chakra-ui/react';
import MapIcon from '@mui/icons-material/Map';
import { GlobalHotKeys } from 'react-hotkeys';

let canvas, ctx, canvasData;

class Map extends React.Component {
  state = {
    hideMap: true,
  };
  toggleMap = (event) => {
    event.preventDefault();
    if (this.state.hideMap) {
      this.setState({
        hideMap: false,
      });
    } else {
      this.setState({
        hideMap: true,
      });
    }
  };

  drawPixel = (x, y, colors, position, Xfloor, Yfloor, size, terrains) => {
    let index = (x + y * size.height) * 4;
    if (x === position.x) {
      canvasData.data[index] = 255;
      canvasData.data[index + 1] = 0;
      canvasData.data[index + 2] = 0;
      canvasData.data[index + 3] = 255;
    } else if (x === position.x + 15) {
      canvasData.data[index] = 255;
      canvasData.data[index + 1] = 0;
      canvasData.data[index + 2] = 0;
      canvasData.data[index + 3] = 255;
    } else if (y === position.y) {
      canvasData.data[index] = 255;
      canvasData.data[index + 1] = 0;
      canvasData.data[index + 2] = 0;
      canvasData.data[index + 3] = 255;
    } else if (y === position.y + 8) {
      canvasData.data[index] = 255;
      canvasData.data[index + 1] = 0;
      canvasData.data[index + 2] = 0;
      canvasData.data[index + 3] = 255;
    } else {
      canvasData.data[index] = colors.r;
      canvasData.data[index + 1] = colors.g;
      canvasData.data[index + 2] = colors.b;
      canvasData.data[index + 3] = 255;
    }

    if (position.x > 0) {
      if (canvasData.data[index - 64] === 255) {
        let newColors = this.colorMap(
          terrains[Yfloor][Xfloor - 1].terrain[y % 9][x % 16]
        );
        canvasData.data[index - 64] = newColors.r;
        canvasData.data[index + 1 - 64] = newColors.g;
        canvasData.data[index + 2 - 64] = newColors.b;
        canvasData.data[index + 3 - 64] = 255;
      }
      if (canvasData.data[index + 64] === 255) {
        let newColors = this.colorMap(
          terrains[Yfloor][Xfloor + 1].terrain[y % 9][x % 16]
        );
        canvasData.data[index + 64] = newColors.r;
        canvasData.data[index + 1 + 64] = newColors.g;
        canvasData.data[index + 2 + 64] = newColors.b;
        canvasData.data[index + 3 + 64] = 255;
      }
    } else if (position.x === 0) {
      if (canvasData.data[index + 64] === 255) {
        let newColors = this.colorMap(
          terrains[Yfloor][Xfloor + 1].terrain[y % 9][x % 16]
        );
        canvasData.data[index + 64] = newColors.r;
        canvasData.data[index + 1 + 64] = newColors.g;
        canvasData.data[index + 2 + 64] = newColors.b;
        canvasData.data[index + 3 + 64] = 255;
      }
    }
    if (position.y > 0) {
      let indexPrev = index - size.height * 4 * 9;
      let indexNext = index + size.height * 4 * 9;
      if (y === position.y) {
        if (canvasData.data[indexPrev] === 255) {
          let newColors = this.colorMap(
            terrains[Yfloor - 1][Xfloor].terrain[y % 9][x % 16]
          );
          canvasData.data[indexPrev] = newColors.r;
          canvasData.data[indexPrev + 1] = newColors.g;
          canvasData.data[indexPrev + 2] = newColors.b;
          canvasData.data[indexPrev + 3] = 255;
        }
        if (canvasData.data[indexNext] === 255) {
          let newColors = this.colorMap(
            terrains[Yfloor + 1][Xfloor].terrain[y % 9][x % 16]
          );
          canvasData.data[indexNext] = newColors.r;
          canvasData.data[indexNext + 1] = newColors.g;
          canvasData.data[indexNext + 2] = newColors.b;
          canvasData.data[indexNext + 3] = 255;
        }
      }
      if (y === position.y + 8) {
        if (canvasData.data[indexPrev] === 255) {
          let newColors = this.colorMap(
            terrains[Yfloor - 1][Xfloor].terrain[y % 9][x % 16]
          );
          canvasData.data[indexPrev] = newColors.r;
          canvasData.data[indexPrev + 1] = newColors.g;
          canvasData.data[indexPrev + 2] = newColors.b;
          canvasData.data[indexPrev + 3] = 255;
        }
        if (canvasData.data[indexNext] === 255) {
          let newColors = this.colorMap(
            terrains[Yfloor + 1][Xfloor].terrain[y % 9][x % 16]
          );
          canvasData.data[indexNext] = newColors.r;
          canvasData.data[indexNext + 1] = newColors.g;
          canvasData.data[indexNext + 2] = newColors.b;
          canvasData.data[indexNext + 3] = 255;
        }
      }
    }
    this.updateCanvas();
  };

  drawBorder = (canvasData, position, size) => {
    console.log('border!');
    for (let i = 0; i < 16; i++) {
      let positionX = (position.x + position.y * size.height + i) * 4;
      console.log(positionX);
      canvasData.data[positionX] = 255;
      canvasData.data[positionX + 1] = 0;
      canvasData.data[positionX + 2] = 0;
      canvasData.data[positionX + 3] = 255;
    }
    /*for (let i=0; i<16; i++) {
            let positionX = (position.x + size.height*9 + position.y * size.height + i) * 4;
            canvasData.data[positionX] = 255;
            canvasData.data[positionX+1] = 0;
            canvasData.data[positionX+2] = 0;
            canvasData.data[positionX+3] = 255;
        }*/
  };

  updateCanvas = () => {
    ctx.putImageData(canvasData, 0, 0);
  };

  colorMap = (itemX) => {
    let r, g, b;
    if (itemX < 0) {
      if (itemX < -0.7) {
        r = 0;
        g = 0;
        b = 139;
      } else if (itemX < -0.3) {
        r = 0;
        g = 0;
        b = 180;
      } else {
        r = 0;
        g = 0;
        b = 255;
      }
    } else if (itemX > 0.1) {
      if (itemX > 1) {
        r = 255;
        g = 255;
        b = 255;
      } else if (itemX > 0.6) {
        r = 0;
        g = 128;
        b = 0;
      } else if (itemX > 0.3) {
        r = 0;
        g = 200;
        b = 0;
      } else {
        r = 0;
        g = 255;
        b = 0;
      }
    } else {
      r = 255;
      g = 255;
      b = 0;
    }

    return { r, g, b };
  };

  render() {
    const { planet, position } = this.props;

    const keyMap = {
      SHOW_MAP: ['m', 'ь'],
    };
    const handlers = {
      SHOW_MAP: this.toggleMap,
    };

    if (planet.size.width > 0) {
      canvas = this.refs.canvas;
      ctx = canvas.getContext('2d');
      canvasData = ctx.getImageData(
        0,
        0,
        planet.size.height,
        planet.size.width
      );
      let Xfloor = Math.floor(position.x / 16),
        Yfloor = Math.floor(position.y / 9);
      planet.terrains[Yfloor][Xfloor].terrain.map(
        function (itemY, indexY) {
          return itemY.map(
            function (itemX, indexX) {
              return this.drawPixel(
                Xfloor * 16 + indexX,
                Yfloor * 9 + indexY,
                this.colorMap(itemX),
                position,
                Xfloor,
                Yfloor,
                planet.size,
                planet.terrains
              );
            }.bind(this)
          );
        }.bind(this)
      );
    }
    return (
      <div className="map">
        <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
        <IconButton
          variant="ghost"
          className="map-toggle"
          onClick={this.toggleMap}
        >
          <MapIcon color="primary" />
        </IconButton>
        <canvas
          ref="canvas"
          hidden={this.state.hideMap}
          width={this.props.planet.size.height}
          height={this.props.planet.size.width}
        />
      </div>
    );
  }
}

export { Map };
